import React from 'react'
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
const Landing = React.lazy(() => import("./components/Landing.jsx"));
const StockCheck = React.lazy(() => import("./components/StockCheck.jsx"));
const BookOrderForm = React.lazy(() => import("./components/BookOrderForm.jsx"));
const B2BOrderPortal = React.lazy(() => import("./components/B2BOrderPortal.jsx"));
const App = () => {
    return (
        <div className="App">
            <Helmet>
                <meta charSet="utf-8" />
                <title>Abhiman | Wear With Pride</title>
                <link rel="icon" href="https://lh3.googleusercontent.com/p/AF1QipPJA6I93ioNlYfTXizp4ZwTve8LlvdK-NwRh3YM=s1360-w1360-h1020" />
            </Helmet>
            <React.Suspense fallback={<div className="h-screen flex items-center justify-center">Loading...</div>}>
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/" component={Landing} />
                        <Route path="/view-stock" component={StockCheck} />
                        <Route exact path="/book-order" component={BookOrderForm} />
                        <Route path="/book-order/portal" component={B2BOrderPortal} />
                    </Switch>
                </BrowserRouter>
            </React.Suspense>
        </div>

    )
}

export default App
